import { useWatch } from 'react-hook-form';
import { ui } from '@procuros/datachecks';

import { DisplayModes } from 'services/webedi/types';

import { FileUploadFieldEdit } from './components/FileUploadFieldEdit';
import { FileUploadFieldView } from './components/FileUploadFieldView';
import { FileUploadValue } from './types';

type FileUploadFieldProps = {
  field: ui.FileUploadField;
  fieldId: string;
  isReadOnly: boolean;
  mode: DisplayModes;
  variant?: 'large';
};

export const FileUploadField = ({ field, fieldId, isReadOnly, mode, variant }: FileUploadFieldProps) => {
  const value = useWatch({ name: fieldId }) as FileUploadValue;

  if (mode === DisplayModes.view) {
    return <FileUploadFieldView field={field} value={value} />;
  }

  return (
    <FileUploadFieldEdit field={field} fieldId={fieldId} isReadOnly={isReadOnly} variant={variant} value={value} />
  );
};
